<template>
  <div class="h-screen">
    <HeaderBar :title="hTitle" />
    <div class="text-xl font-bold my-2">
      You may move-in the unit once the following have been complied:
    </div>
    <ul class="list-disc">
      <li>Documents required</li>
      <li>Payments required</li>
      <li>Unit is ready for turnover</li>
    </ul>
  </div>
</template>
<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar },
};
</script>